import {DatePicker} from '@mui/x-date-pickers';

import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import type {Dayjs} from 'dayjs';
import type {FC} from 'react';
import 'dayjs/locale/ca';
import 'dayjs/locale/en';
import type {SxProps} from '@mui/material';
import {lighten} from '@mui/system/colorManipulator';
import i18n from 'i18next';
import {useTranslation} from 'react-i18next';
import {secondaryColor} from '@/theme/theme';

//TYPES
export type Props = {
  value?: Dayjs;
  maxDate?: Dayjs;
  minDate?: Dayjs;
  onChange: (newValue?: Dayjs) => void;
};

const CalendarPicker: FC<Props> = ({value, maxDate, minDate, onChange}) => {
  const {t} = useTranslation();
  const lang = i18n.resolvedLanguage;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={{todayButtonLabel: t('forestMass.today')}}
      adapterLocale={lang}
    >
      <DatePicker
        format="DD/MM/YYYY"
        maxDate={maxDate}
        minDate={minDate}
        value={value}
        slotProps={{
          popper: {sx: {...styles.datePickerPopper}},
          layout: {sx: {...styles.datePickerLayout}},
          actionBar: {
            sx: {...styles.datePickerActionBar},
          },
          textField: {
            size: 'small',
            InputLabelProps: {sx: {...styles.datePickerTextField}},
            InputProps: {sx: {...styles.inputProps}},
          },
          field: {clearable: false},
        }}
        sx={styles.calendar}
        onChange={(day: Dayjs | null) => onChange(day == null ? undefined : day)}
      />
    </LocalizationProvider>
  );
};
export default CalendarPicker;

const styles: Record<string, SxProps> = {
  datePickerPopper: {
    opacity: 0.95,
    zIndex: 2000,
  },
  datePickerLayout: {
    '& .MuiPaper-root': {opacity: 0.5},
  },
  datePickerActionBar: {
    justifyContent: 'center',
    '& .MuiButtonBase-root': {
      width: '100px',
      border: 1,
      borderColor: 'primary.main',
      mb: 1,
    },
  },
  datePickerTextField: {
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
  },
  calendar: {
    flex: 1,
    bgcolor: lighten(secondaryColor, 0.95),
  },
  inputProps: {
    borderRadius: '0px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px', // radio de fieldset

      '& fieldset': {
        borderRadius: '12px',
      },
      '&:hover fieldset': {
        borderColor: 'primary.main', // borde hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'secondary.main', // borde focus
      },
    },
  },
};
